import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import UserService from '../../../../../services/users-auth';
import { Link, useParams, Navigate } from 'react-router-dom';


const Fiscal = () => {
    let { id } = useParams()

    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [nivel, setNivel] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState("");

    async function fetchFiscal(id) {
        const response = await UserService.userEdit(id);
        setNome(response.data["nome_fiscal"]);
        setEmail(response.data["email"]);
        setNivel(response.data["nivel"]);
    }

    useEffect(() => {
        fetchFiscal(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const fiscal = await UserService.editar(id, {
                nome_fiscal: nome,
                email: email,
                nivel: nivel
            })
            if (fiscal.data["cod_fiscal"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={3}>
                        <Col>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="email">
                                <FloatingLabel
                                    label="E-mail"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="nivel">
                                <FloatingLabel
                                    label="Nível"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="nivel"
                                        name="nivel"
                                        onChange={e => setNivel(e.target.value)}
                                    >
                                        <option value={nivel}>{nivel}</option>
                                        <option value="Legislador">Legislador</option>
                                        <option value="Licitador">Licitador</option>
                                        <option value="Administrador">Administrador</option>
                                        <option value="Controle Interno">Controle Interno</option>
                                        <option value="Saude">Saude</option>
                                        <option value="Educação">Educação</option>
                                        <option value="Obras">Obras</option>
                                        <option value="RH">RH</option>
                                        <option value="Ouvidor">Ouvidor</option>
                                        <option value="Diario">Diario</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/usuarios/listar'}>
                    <Button variant="danger" type="button">
                        Cancelar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Fiscal editado com sucesso!</Alert>
                <Navigate to={'/restrito/usuarios/listar'} />
            </Fragment>
        )
    }
}

export default Fiscal;